import api from './api'

export const emailNotificationService = {
  getNotifications: async (params = {}) => {
    const response = await api.get('/email-notifications', { params })
    return response.data
  },

  getUnreadCount: async () => {
    const response = await api.get('/email-notifications/unread-count')
    return response.data
  },

  markAsRead: async (id) => {
    const response = await api.patch(`/email-notifications/${id}/read`)
    return response.data
  },

  markAllAsRead: async () => {
    const response = await api.post('/email-notifications/mark-all-read')
    return response.data
  }
}
